<template>
  <v-app light>
    <v-navigation-drawer
      temporary
      :right="true"
      :mini-variant="miniVariant"
      :clipped="clipped"
      v-model="leftDrawer"
      enable-resize-watcher
      fixed
      app
    >
      <v-list>
        <v-list-tile
          v-for="(item, i) in items"
          :key="`items_${i}`"
          @click="redirect(item.link)"
        >
          
          <v-list-tile-content>
            <v-list-tile-title class="text-xs-right" v-text="item.title"></v-list-tile-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-img :src="item.logo"></v-img>
          </v-list-tile-action>
        </v-list-tile>

        <v-list-tile>
          <v-list-tile-action>
            <v-btn icon @click.stop="miniVariant = !miniVariant">
              <v-icon v-html="!miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

      </v-list>
    </v-navigation-drawer>

    <v-toolbar fixed app>

    <!-- <v-btn icon @click.stop="leftDrawer = true">
      <v-icon>menu</v-icon>
    </v-btn>
    <v-divider vertical></v-divider> -->
      
      <v-toolbar-title>
          <img src="https://developers.hubculture.com/chat-zeke/logo.png" alt="" width="36" class="logo"> <span class="vertical-super">{{ title }}</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        icon
        light
        @click.stop="leftDrawer = !leftDrawer"
      >
        <v-icon>menu</v-icon>
      </v-btn>
    </v-toolbar>
    <v-content>
      <router-view></router-view>
    </v-content>
    <v-navigation-drawer
      temporary
      :right="right"
      v-model="rightDrawer"
      fixed
    >
      <v-list>
        <v-list-tile @click="right = !right">
          <v-list-tile-action>
            <v-icon light>compare_arrows</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>Switch drawer (click me)</v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
  </v-app>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'

  export default {
    data () {
      return {
        cordova: Vue.cordova,
        miniVariant: true,
        right: true,
        clipped: false,
        rightDrawer: false,
        leftDrawer: false,
        title: 'Zeke',
        items: []
      }
    },
    created () {
      this.fetchItems()

      var self = this
      this.cordova.on('deviceready', () => {
        self.onDeviceReady()
      })
    },
    methods: {
      redirect (link) {
        window.open(link, '_blank')
      },
      fetchItems () {
        axios.get('/projects').then(response => {
          this.items = response.data.data
        })
      },
      onDeviceReady: function () {
        // Handle the device ready event.
        this.cordova.on('pause', this.onPause, false)
        this.cordova.on('resume', this.onResume, false)
        if (this.cordova.device.platform === 'Android') {
          document.addEventListener('backbutton', this.onBackKeyDown, false)
        }
      },
      onPause () {
        // Handle the pause lifecycle event.
        console.log('pause')
      },
      onResume () {
        // Handle the resume lifecycle event.
        // SetTimeout required for iOS.
        setTimeout(function () {
          console.log('resume')
        }, 0)
      },
      onBackKeyDown () {
        // Handle the back-button event on Android. By default it will exit the app.
        navigator.app.exitApp()
      }
    }
  }
</script>

<style>
	body {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
	}
  .footer{ /* Apply this to v-bottom-nav if necessary. */
    margin-bottom: constant(safe-area-inset-bottom);
    margin-bottom: env(safe-area-inset-bottom);
  }
  .v-toolbar__title:not(:first-child) {
    margin-left: 6px!important;
  }
  .vertical-super {
    vertical-align: super;
  }
  .logo {
    margin-top: 5px;
  }
</style>
